/**
 * 广告数据分析
 */
import axios from '../../utils/axios'

// asin列表展示
export function show_asin_list(data) {
    return axios({
        url: "/apis/seed_word/show_asin_list",
        method: "get",
        params: data
    });
}
// 获取广告组名称
export function get_ad_portfolio_name_id(data) {
    return axios({
        url: "/apis/seed_word/get_ad_portfolio_name_id",
        method: "POST",
        data: data
    });
}
// 修改广告组名称
export function update_ad_portfolio_name_id(data) {
    return axios({
        url: "/apis/seed_word/update_ad_portfolio_name_id",
        method: "POST",
        data: data
    });
}

// 词根数据展示
export function show_table1_detail(data) {
    return axios({
        url: "/apis/seed_word/show_table1_detail",
        method: "get",
        params: data
    });
}

// 否定词根数据展示
export function show_table2_detail(data) {
    return axios({
        url: "/apis/seed_word/show_table2_detail",
        method: "get",
        params: data
    });
}

// 种子词库数据展示
export function show_table3_detail(data) {
    return axios({
        url: "/apis/seed_word/show_table3_detail",
        method: "get",
        params: data
    });
}

// 已打广告词数据展示
export function show_table4_detail(data) {
    return axios({
        url: "/apis/seed_word/show_table4_detail",
        method: "get",
        params: data
    });
}

// 无效词数据展示
export function show_table5_detail(data) {
    return axios({
        url: "/apis/seed_word/show_table5_detail",
        method: "get",
        params: data
    });
}

// 词库排除数据展示
export function show_table6_detail(data) {
    return axios({
        url: "/apis/seed_word/show_table6_detail",
        method: "get",
        params: data
    });
}

// 添加asin
export function add_asin_to_relevance(data) {
    return axios({
        url: "/apis/seed_word/add_asin_to_relevance",
        method: "get",
        params: data
    });
}

// 获取单个asin信息
export function show_asin_detail_by_asin(data) {
    return axios({
        url: "/apis/seed_word/show_asin_detail_by_asin",
        method: "get",
        params: data
    });
}

//上传词根数据
export function etyma_file_upload(consumerName, data) {
    return axios({
        url: "/apis/seed_word/etyma_file_upload",
        method: "post",
        params: consumerName,
        data: data
    });
}

//上传否认词根数据
export function disavowal_etyma_file_upload(consumerName, data) {
    return axios({
        url: "/apis/seed_word/disavowal_etyma_file_upload",
        method: "post",
        params: consumerName,
        data: data
    });
}

//上传已打广告词数据
export function ading_word_file_upload(consumerName, data) {
    return axios({
        url: "/apis/seed_word/ading_word_file_upload",
        method: "post",
        params: consumerName,
        data: data
    });
}

//上传无效词数据
export function invalid_word_file_upload(consumerName, data) {
    return axios({
        url: "/apis/seed_word/invalid_word_file_upload",
        method: "post",
        params: consumerName,
        data: data
    });
}

//上传种子词库数据
export function seed_word_file_upload(consumerName, data) {
    return axios({
        url: "/apis/seed_word/seed_word_file_upload",
        method: "post",
        params: consumerName,
        data: data
    });
}

//上传词库排除数据
export function eliminate_word_file_upload(consumerName, data) {
    return axios({
        url: "/apis/seed_word/eliminate_word_file_upload",
        method: "post",
        params: consumerName,
        data: data
    });
}

//种子词库导出导出
export function seed_keyword_file_export(data) {
    return axios({
        url: "/apis/seed_word/seed_keyword_file_export",
        method: "get",
        params: data
    });
}
//asin导出
export function asin_keyword_file_export(data) {
    return axios({
        url: "/apis/seed_word/asin_keyword_file_export",
        method: "get",
        params: data
    });
}
//批量删除数据
export function batch_delete(data) {
    return axios({
        url: "/apis/seed_word/batch_delete",
        method: "post",
        data: data
    });
}

//添加关键词到爬虫
export function add_keyword_to_spider(data) {
    return axios({
        url: "/apis/seed_word/add_keyword_to_spider",
        method: "post",
        data: data
    });
}

//获取ara趋势
export function ara_trend_batch(data) {
    return axios({
        url: "/apis/seed_word/ara_trend_batch",
        method: "post",
        data: data
    });
}

//获取降bid提醒
export function lower_bid_remind(data) {
    return axios({
        url: "/apis/seed_word/lower_bid_remind",
        method: "post",
        data: data
    });
}

//获取种子词的rank排名
export function get_seed_word_rank_detail(data) {
    return axios({
        url: "/apis/seed_word/get_seed_word_rank_detail",
        method: "post",
        data: data
    });
}

//获取关键词排名趋势
export function keyword_rank_batch(data) {
    return axios({
        url: "/apis/seed_word/keyword_rank_batch",
        method: "post",
        data: data
    });
}

//修改备注信息
export function update_remark(data) {
    return axios({
        url: "/apis/seed_word/update_remark",
        method: "post",
        data: data
    });
}

//自动否定无效词根
export function auto_negate_etyma(consumerName, data) {
    return axios({
        url: "/apis/seed_word/auto_negate_etyma",
        method: "post",
        params: consumerName,
        data: data
    });
}

//自动适配品牌
export function auto_add_brand(data) {
    return axios({
        url: "/apis/seed_word/auto_add_brand",
        method: "post",
        data: data
    });
}

//通用获取进度条信息
export function get_progress_bar_detail(data) {
    return axios({
        url: "/apis/v1/get_progress_bar_detail",
        method: "post",
        data: data
    });
}

//自动适配广告组
export function auto_add_ad_group(data) {
    return axios({
        url: "/apis/seed_word/auto_add_ad_group",
        method: "post",
        data: data
    });
}

//获取广告组单词的单复数
export function get_ad_group_word_plural(data) {
    return axios({
        url: "/apis/seed_word/get_ad_group_word_plural",
        method: "get",
        params: data
    });
}

//修改广告组单词的单复数
export function update_ad_group_word_plural(data) {
    return axios({
        url: "/apis/seed_word/update_ad_group_word_plural",
        method: "post",
        data: data
    });
}

//更新asin信息(接口)
export function update_asin_detail(data) {
    return axios({
        url: "/apis/seed_word/update_asin_detail",
        method: "get",
        params: data
    });
}

//上传核心词根数据
export function core_etyma_file_upload(consumerName, data) {
    return axios({
        url: "/apis/seed_word/core_etyma_file_upload",
        method: "post",
        params: consumerName,
        data: data
    });
}

//核心词根数据展示
export function show_core_etyma_detail(data) {
    return axios({
        url: "/apis/seed_word/show_core_etyma_detail",
        method: "get",
        params: data
    });
}
//核心词根数据展示
export function show_keyword_asin_detail(data) {
    return axios({
        url: "/apis/seed_word/show_keyword_asin_detail",
        method: "get",
        params: data
    });
}

//修改关联关系
export function update_relevance_detail(data) {
    return axios({
        url: "/apis/seed_word/update_relevance_detail",
        method: "post",
        data: data
    });
}

//前三页数据个数展示
export function get_three_page_total(data) {
    return axios({
        url: "/apis/seed_word/new_get_three_page_total",
        method: "post",
        data: data
    });
}
//前三页数据查询记录展示
export function out_three_page_show(data) {
    return axios({
        url: "/apis/spider_data/out_three_page_show",
        method: "post",
        data: data
    });
}
//前三页数据查询记录添加
export function out_three_page_add(data) {
    return axios({
        url: "/apis/spider_data/out_three_page_add",
        method: "post",
        data: data
    });
}
//前三页数据查询记录删除
export function out_three_page_delete(data) {
    return axios({
        url: "/apis/spider_data/out_three_page_delete",
        method: "post",
        data: data
    });
}

// sp否定投放词映射-导入
export function negative_mapping_import(data) {
    return axios({
        url: "/admin/ad_for_sp/negative_mapping/import",
        method: "post",
        data: data
    });
}
